import { useQuery } from 'react-query'
import { mapToWorkspaceMerchantsPage } from 'api/mappers/merchant'
import { GetMerchantsRequest } from 'lib/generated/api'
import { useApiClient } from 'contexts/ApiClientContext'

export const QUERY_KEYS = {
  merchant: 'merchant',
  workspaceMerchants: 'workspaceMerchants',
}

export const workspaceMerchantsQueryKey = ({
  workspaceId,
  ...queryParams
}: GetMerchantsRequest) => [
  QUERY_KEYS.workspaceMerchants,
  workspaceId,
  queryParams,
]

export const useWorkspaceMerchantsQuery = (request: GetMerchantsRequest) => {
  const { merchantApi } = useApiClient()

  return useQuery(
    workspaceMerchantsQueryKey(request),
    () => merchantApi.getMerchants(request),
    {
      enabled: !!request.workspaceId,
      keepPreviousData: true,
      select: mapToWorkspaceMerchantsPage,
    }
  )
}
